var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecrees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "Decrees",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5,32.88a1.5,1.5,0,0,0-3,0v8.59L37.4,26a1.51,1.51,0,0,0-2.3,0l-7.45,8.87L13.15,17.48a1.5,1.5,0,0,0-2.3,1.92L26.49,38.21a1.49,1.49,0,0,0,1.15.54,1.51,1.51,0,0,0,1.15-.53l7.47-8.89,12.5,14.73H39.32a1.5,1.5,0,0,0,0,3H52a1.54,1.54,0,0,0,1.37-.88,1.69,1.69,0,0,0,.14-.62Z",
    fill: "#ff6347",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrees);
export default __webpack_public_path__ + "static/media/decrees.56d0d5c13798f7dddfa74345d6fa76b2.svg";
export { ForwardRef as ReactComponent };